import React, { Component } from "react";
import { Grid, Box } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtTxt from "./CustomTool/CtTxt";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import { Edit, Delete, Print } from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import CtCheckBox from "./CustomTool/CtCheckBox";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { fetchCustomerMaster } from "./API";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import { styled } from "@mui/system";
import GstInfo from "./GstInfo";
import {
  getRowData,
  isValidItem,
  applyTrimOnObjectValues,
  setKeyboardShortcuts,
  csvFileName,
  getRowOfRT,
} from "../SystemUtility/SystemUtility";
import ReferenceMaster from "./ReferenceMaster";
import CtART from "./CustomTool/ResponsiveTable";

const StyledGrid = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up("xs")]: {
    maxWidth: "90%",
  },
  [theme.breakpoints.up("sm")]: {
    maxWidth: "540px",
  },
}));
class CustomerMaster extends Component {
  state = {
    CompanyCode: [],
    CompanyName: [],
    City: [],
    company: [],
    State: [],
    GeneralSettingList: [],
    Reference: [],
    CrDr: [{ Type: "CR" }, { Type: "DR" }],
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      //   { id: "bint_srno", label: "SR NO" },
      { id: "vac_companyname", label: "Company Code", hide: "true" },
      { id: "vac_customername", label: "Company Name", hide: "true" },
      { id: "vac_gstin", label: "GST IN" },
      { id: "vac_customer", label: "Customer Name" },
      { id: "vac_billingname", label: "Billing Name" },
      { id: "vac_personname", label: "Person Name" },
      { id: "vac_referencename", label: "Reference Name" },
      { id: "vac_address", label: "Address" },
      { id: "vac_city", label: "City" },
      { id: "vac_state", label: "State" },
      { id: "vac_statecode", label: "State Code" },
      { id: "vac_pincode", label: "Pin Code" },
      { id: "vac_panno", label: "PAN NO" },
      { id: "vac_mobileno1", label: "Mobile 1" },
      { id: "vac_mobileno2", label: "Mobile 2" },
      { id: "vac_email1", label: "Email 1" },
      { id: "vac_email2", label: "Email 2" },
      { id: "vac_openingamountcrdr", label: "Cr/Dr" },
      { id: "dec_openingamount", label: "Opening Amount" },
      { id: "vac_remark", label: "Remark" },
    ],
    rows: [],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "CustomerMaster:",
        actionType: "AlertResponsive",
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "CustomerMaster:",
        actionType: "AlertResponsive",
      },
    ],
    keyColumn: [
      "bint_acid",
      "vac_company",
      "vac_gstin",
      "vac_customer",
      "vac_billingname",
      "vac_personname",
      "vac_referencename",
      "vac_address",
      "vac_city",
      "vac_state",
      "vac_statecode",
      "vac_panno",
      "vac_mobileno1",
      "vac_mobileno2",
      "vac_email1",
      "vac_email2",
      "vac_openingamountcrdr",
      "dec_openingamount",
      "vac_remark",
      "vac_pincode",
    ],
    columnsdata: [
      { accessorKey: "vac_companyname", header: "Company Code", hide: true },
      { accessorKey: "vac_customername", header: "Company Name", hide: true },
      { accessorKey: "vac_gstin", header: "GST IN" },
      { accessorKey: "vac_customer", header: "Customer Name" },
      { accessorKey: "vac_billingname", header: "Billing Name" },
      { accessorKey: "vac_personname", header: "Person Name" },
      { accessorKey: "vac_referencename", header: "Reference Name" },
      { accessorKey: "vac_address", header: "Address" },
      { accessorKey: "vac_city", header: "City" },
      { accessorKey: "vac_state", header: "State" },
      { accessorKey: "vac_statecode", header: "State Code" },
      { accessorKey: "vac_pincode", header: "Pin Code" },
      { accessorKey: "vac_panno", header: "PAN NO" },
      { accessorKey: "vac_mobileno1", header: "Mobile 1" },
      { accessorKey: "vac_mobileno2", header: "Mobile 2" },
      { accessorKey: "vac_email1", header: "Email 1" },
      { accessorKey: "vac_email2", header: "Email 2" },
      { accessorKey: "vac_openingamountcrdr", header: "Cr/Dr" },
      { accessorKey: "dec_openingamount", header: "Opening Amount" },
      { accessorKey: "vac_remark", header: "Remark" },
    ],
    formData: {
      EditCustomerName: "",
      bint_srno: "",
      txtCompany: "",
      txtGSTIN: "",
      txtCustomerName: "",
      txtBillingName: "",
      txtPersonName: "",
      cmbReference: "",
      txtAddress: "",
      cmbCity: "",
      cmbState: "Gujarat",
      txtStateCode: "24",
      txtPinCode: "",
      txtPANNo: "",
      txtMobileNo1: "",
      txtMobileNo2: "",
      txtEmail1: "",
      txtEmail2: "",
      cmbCrDr: "CR",
      txtOpeningAmount: "",
      txtRemark: "",
      txtEditCustomer: "",
    },
    searchData: {
      vac_gstin: "",
      vac_customer: "",
      vac_billingname: "",
      vac_personname: "",
      vac_referencename: "",
      vac_address: "",
      vac_city: "",
      vac_state: "",
      vac_statecode: "",
      vac_pincode: "",
      vac_panno: "",
      vac_mobileno1: "",
      vac_mobileno2: "",
      vac_email1: "",
      vac_email2: "",
      vac_openingamountcrdr: "",
      dec_openingamount: "",
      vac_remark: "",
    },
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,
    removeKeyboardShortCuts: null,
  };

  //#region Component
  componentDidMount() {
    {
      !this.props.showHeading &&
        (document.title = "RiTe Account : Customer Master");
    }
    this.props.setActiveMenu("CustomerMaster");
    this.ShortCut();
    this.setSearchColumns();
    this.props.verifyUserID(
      this.getInfo,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
    // this.getInfo();
  }

  componentWillUnmount() {
    this.removeShortCut();
  }
  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "txtGSTIN") {
          let GSTIN = this.state.formData.txtGSTIN.substring(2, 12);
          this.setState({
            formData: { ...this.state.formData, txtPANNo: GSTIN },
          });
        } else if (e.target.name === "cmbState") {
          let txtStateCode = this.state.formData.txtStateCode;
          this.state.State.map((curState) => {
            if (e.target.value === curState.vac_state) {
              txtStateCode = curState.vac_statecode;
            }
          });
          this.setState({
            formData: { ...this.state.formData, txtStateCode },
          });
        }
      }
    );
  };
  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };
  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleARDonActionClick = (row) => {
    console.log("row", row);

    const bint_srno = row.bint_acid,
      txtCompany = row.vac_company,
      txtGSTIN = row.vac_gstin,
      EditCustomerName = row.vac_customer,
      txtCustomerName = row.vac_customer,
      txtBillingName = row.vac_billingname,
      txtPersonName = row.vac_personname,
      cmbReference = row.vac_referencename,
      txtAddress = row.vac_address,
      cmbCity = row.vac_city,
      cmbState = row.vac_state,
      txtStateCode = row.vac_statecode,
      txtPANNo = row.vac_panno,
      txtMobileNo1 = row.vac_mobileno1,
      txtMobileNo2 = row.vac_mobileno2,
      txtEmail1 = row.vac_email1,
      txtEmail2 = row.vac_email2,
      cmbCrDr = row.vac_openingamountcrdr,
      txtOpeningAmount = row.dec_openingamount,
      txtRemark = row.vac_remark,
      txtPinCode = row.vac_pincode,
      actionName = row.actionName;
    if (actionName === "Edit") {
      this.setState({
        formData: {
          ...this.state.formData,
          bint_srno,
          txtCompany,
          txtGSTIN,
          EditCustomerName,
          txtCustomerName,
          txtBillingName,
          txtPersonName,
          txtAddress,
          cmbCity,
          cmbState,
          txtStateCode,
          txtPinCode,
          txtPANNo,
          txtMobileNo1,
          txtMobileNo2,
          txtEmail1,
          txtEmail2,
          cmbCrDr,
          txtOpeningAmount,
          txtRemark,
          cmbReference,
        },
      });
      window.scrollTo(0, 0);
      document.getElementById("txtGSTIN").focus();
    } else if (actionName === "Delete") {
      this.DeleteData(EditCustomerName);
    } else {
      let rows = this.state.rows.filter((row) => {
        if (
          row.bint_acid !== bint_srno &&
          row.vac_company !== txtCompany &&
          row.vac_gstin !== txtGSTIN &&
          row.vac_customer !== txtCustomerName &&
          row.vac_billingname !== txtBillingName &&
          row.vac_personname !== txtPersonName &&
          row.vac_referencename !== cmbReference &&
          row.vac_address !== txtAddress &&
          row.vac_city !== cmbCity &&
          row.vac_state !== cmbState &&
          row.vac_statecode !== txtStateCode &&
          row.vac_panno !== txtPANNo &&
          row.vac_mobileno1 !== txtMobileNo1 &&
          row.vac_mobileno2 !== txtMobileNo2 &&
          row.vac_email1 !== txtEmail1 &&
          row.vac_email2 !== txtEmail2 &&
          row.vac_openingamountcrdr !== cmbCrDr &&
          row.dec_openingamount !== txtOpeningAmount &&
          row.vac_remark !== txtRemark
        )
          return row;
      });
      const rowsCount = rows.length;
      this.setState({ rows, rowsCount });
    }
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, ["vac_customer"]),
      EditCustomerName = row.vac_customer;
    this.DeleteData(EditCustomerName);
  };

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, [
      "bint_acid",
      "vac_company",
      "vac_gstin",
      "vac_customer",
      "vac_customer",
      "vac_billingname",
      "vac_personname",
      "vac_referencename",
      "vac_address",
      "vac_city",
      "vac_state",
      "vac_statecode",
      "vac_panno",
      "vac_mobileno1",
      "vac_mobileno2",
      "vac_email1",
      "vac_email2",
      "vac_openingamountcrdr",
      "dec_openingamount",
      "vac_remark",
      "vac_pincode",
    ]);
    const bint_srno = row.bint_acid,
      txtCompany = row.vac_company,
      txtGSTIN = row.vac_gstin,
      EditCustomerName = row.vac_customer,
      txtCustomerName = row.vac_customer,
      txtBillingName = row.vac_billingname,
      txtPersonName = row.vac_personname,
      cmbReference = row.vac_referencename,
      txtAddress = row.vac_address,
      cmbCity = row.vac_city,
      cmbState = row.vac_state,
      txtStateCode = row.vac_statecode,
      txtPANNo = row.vac_panno,
      txtMobileNo1 = row.vac_mobileno1,
      txtMobileNo2 = row.vac_mobileno2,
      txtEmail1 = row.vac_email1,
      txtEmail2 = row.vac_email2,
      cmbCrDr = row.vac_openingamountcrdr,
      txtOpeningAmount = row.dec_openingamount,
      txtRemark = row.vac_remark,
      txtPinCode = row.vac_pincode;

    this.setState({
      formData: {
        ...this.state.formData,
        bint_srno,
        txtCompany,
        txtGSTIN,
        EditCustomerName,
        txtCustomerName,
        txtBillingName,
        txtPersonName,
        txtAddress,
        cmbCity,
        cmbState,
        txtStateCode,
        txtPinCode,
        txtPANNo,
        txtMobileNo1,
        txtMobileNo2,
        txtEmail1,
        txtEmail2,
        cmbCrDr,
        txtOpeningAmount,
        txtRemark,
        cmbReference,
      },
    });
    window.scrollTo(0, 0);
    document.getElementById("txtGSTIN").focus();
  };

  handleOnSearchInputChange = (e) => {
    // console.log('handleOnSearchInputChange', [e.target.name], e.target.value, this.state.searchData);
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
        // console.log(this.state.searchData)
      }
    );
  };

  handleOnSearchInputChangeTrim = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value.trim(),
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
      }
    );
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row, index) => {
        if (
          searchOpen === true &&
          (this.state.searchData.vac_gstin.length === 0 ||
            (row["vac_gstin"] &&
              row["vac_gstin"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_gstin.toLowerCase()))) &&
          (this.state.searchData.vac_customer.length === 0 ||
            (row["vac_customer"] &&
              row["vac_customer"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_customer.toLowerCase()))) &&
          (this.state.searchData.vac_billingname.length === 0 ||
            (row["vac_billingname"] &&
              row["vac_billingname"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_billingname.toLowerCase()
                ))) &&
          (this.state.searchData.vac_personname.length === 0 ||
            (row["vac_personname"] &&
              row["vac_personname"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_personname.toLowerCase()
                ))) &&
          (this.state.searchData.vac_referencename.length === 0 ||
            (row["vac_referencename"] &&
              row["vac_referencename"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_referencename.toLowerCase()
                ))) &&
          (this.state.searchData.vac_address.length === 0 ||
            (row["vac_address"] &&
              row["vac_address"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_address.toLowerCase()))) &&
          (this.state.searchData.vac_city === "" ||
            (row["vac_city"] &&
              row["vac_city"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_city.toLowerCase()))) &&
          (this.state.searchData.vac_state === "" ||
            (row["vac_state"] &&
              row["vac_state"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_state.toLowerCase()))) &&
          (this.state.searchData.vac_statecode.length === 0 ||
            (row["vac_statecode"] &&
              row["vac_statecode"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_statecode.toLowerCase()
                ))) &&
          (this.state.searchData.vac_pincode.length === 0 ||
            (row["vac_pincode"] &&
              row["vac_pincode"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_pincode.toLowerCase()))) &&
          (this.state.searchData.vac_panno.length === 0 ||
            (row["vac_panno"] &&
              row["vac_panno"]
                .toString()
                .includes(this.state.searchData.vac_panno))) &&
          (this.state.searchData.vac_mobileno1.length === 0 ||
            (row["vac_mobileno1"] &&
              row["vac_mobileno1"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_mobileno1.toLowerCase()
                ))) &&
          (this.state.searchData.vac_mobileno2.length === 0 ||
            (row["vac_mobileno2"] &&
              row["vac_mobileno2"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_mobileno2.toLowerCase()
                ))) &&
          (this.state.searchData.vac_email1.length === 0 ||
            (row["vac_email1"] &&
              row["vac_email1"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_email1.toLowerCase()))) &&
          (this.state.searchData.vac_email2.length === 0 ||
            (row["vac_email2"] &&
              row["vac_email2"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_email2.toLowerCase()))) &&
          (this.state.searchData.vac_openingamountcrdr === "" ||
            this.state.searchData.vac_openingamountcrdr ===
              row["vac_openingamountcrdr"]) &&
          (this.state.searchData.dec_openingamount.length === 0 ||
            (row["dec_openingamount"] &&
              row["dec_openingamount"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.dec_openingamount.toLowerCase()
                ))) &&
          (this.state.searchData.vac_remark.length === 0 ||
            (row["vac_remark"] &&
              row["vac_remark"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_remark.toLowerCase())))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState({
        searchOpen,
        searchRows,
        searchRowsCount,
        counter: this.state.counter + 1,
      });
    } else {
      this.setState({ searchOpen });
    }
  };
  //#endregion handle

  //#region function
  ShortCut = () => {
    this.removeShortCut = setKeyboardShortcuts(
      {
        handleOnclickSave: this.SaveCustomerMaster,
        handleOnclickNew: this.clearInfo,
        handleOnclickDelete: () => {
          this.DeleteData(this.state.formData.EditCustomerName);
        },
        handleOnclickPluse: this.onAddClickReference,
      }

      // this.saveSales(true)
    );
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validateCustomer = () => {
    let result = false;

    /* if (this.state.formData.cmbCompanyName.length <= 0) {
            this.props.toastErrorMsg('Enter Company Name', 'cmbCompanyName')
        } */
    /*  else if (this.state.formData.cmbState.length <= 0) {
     this.props.toastErrorMsg('Enter State', 'cmbState')
 } */

    let AddressValidation = getRowData(
        this.state.GeneralSettingList,
        "vac_key",
        "Address Validation"
      ),
      MobNo1Validation = getRowData(
        this.state.GeneralSettingList,
        "vac_key",
        "Mobile No. 1 Validation"
      ),
      MobNo2Validation = getRowData(
        this.state.GeneralSettingList,
        "vac_key",
        "Mobile No. 2 Validation"
      );
    if (this.state.formData.txtCustomerName.length <= 0) {
      this.props.toastErrorMsg("Enter Customer Name", "txtCustomerName");
    } else if (
      AddressValidation.vac_value === "Mandatory" &&
      this.state.formData.txtAddress.length <= 0
    ) {
      this.props.toastErrorMsg("Enter Address", "txtAddress");
    } else if (this.state.formData.cmbState.length <= 0) {
      this.props.toastErrorMsg("Select State", "cmbState");
    } else if (
      this.state.formData.cmbReference.length > 0 &&
      isValidItem(
        this.state.Reference,
        "vac_referencename",
        this.state.formData.cmbReference
      ) == false
    ) {
      this.props.toastErrorMsg("Select Valid Reference Name", "cmbReference");
    } else if (this.validateState() === false) {
      this.props.toastErrorMsg("Select valid State", "cmbState");
    } else if (this.state.formData.txtPinCode.length <= 0) {
      this.props.toastErrorMsg("Enter Pin Code", "txtPinCode");
    } else if (this.state.formData.txtPinCode.length != 6) {
      this.props.toastErrorMsg("Enter 6 digit Pin Code", "txtPinCode");
    } else if (
      this.state.formData.cmbCrDr.length > 0 &&
      this.state.formData.cmbCrDr != "CR" &&
      this.state.formData.cmbCrDr != "DR"
    ) {
      this.props.toastErrorMsg("Select valid CR/DR", "cmbCrDr");
    } else if (
      this.state.formData.txtGSTIN != undefined &&
      this.state.formData.txtGSTIN.trim().length !== 0 &&
      this.state.formData.txtGSTIN.trim().length < 15
    ) {
      this.props.toastErrorMsg("Enter 15 Digit valid GST NO", "txtGSTIN");
    } else if (
      this.state.formData.txtPANNo != undefined &&
      this.state.formData.txtPANNo.trim().length !== 0 &&
      this.state.formData.txtPANNo.trim().length < 10
    ) {
      this.props.toastErrorMsg("Enter 10 Digit PAN NO", "txtPANNo");
    } else if (
      MobNo1Validation.vac_value === "Mandatory" &&
      this.state.formData.txtMobileNo1.trim().length <= 0
    ) {
      this.props.toastErrorMsg("Enter Mobile No. 1", "txtMobileNo1");
    } else if (
      this.state.formData.txtMobileNo1 != undefined &&
      this.state.formData.txtMobileNo1.trim().length !== 0 &&
      this.state.formData.txtMobileNo1.trim().length < 10
    ) {
      this.props.toastErrorMsg(
        "Enter 10 Digits valid Mobile No. 1",
        "txtMobileNo1"
      );
    } else if (
      MobNo2Validation.vac_value === "Mandatory" &&
      this.state.formData.txtMobileNo2.trim().length <= 0
    ) {
      this.props.toastErrorMsg("Enter Mobile No. 2", "txtMobileNo2");
    } else if (
      this.state.formData.txtMobileNo2 != undefined &&
      this.state.formData.txtMobileNo2.trim().length !== 0 &&
      this.state.formData.txtMobileNo2.trim().length < 10
    ) {
      this.props.toastErrorMsg(
        "Enter 10 Digits valid Mobile No. 2",
        "txtMobileNo2"
      );
    } else if (
      this.state.formData.txtEmail1 != undefined &&
      this.state.formData.txtEmail1.trim().length !== 0 &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
        this.state.formData.txtEmail1
      )
    ) {
      this.props.toastErrorMsg("Enter Valid Email 1", "txtEmail1");
    } else if (
      this.state.formData.txtGSTIN != undefined &&
      this.state.formData.txtEmail2.trim().length !== 0 &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
        this.state.formData.txtEmail2
      )
    ) {
      this.props.toastErrorMsg("Enter Valid Email 2", "txtEmail2");
    } else {
      result = true;
    }
    return result;
  };

  validateGstInfo = () => {
    let result = false;
    if (this.state.formData.txtGSTIN.trim().length <= 0) {
      this.props.toastErrorMsg("Enter GSTNO", "txtGSTIN");
    } else if (this.state.formData.txtGSTIN.trim().length < 15) {
      this.props.toastErrorMsg("Enter 15 Digit GSTNO", "txtGSTIN");
    } else {
      result = true;
    }
    return result;
  };

  validateState = () => {
    let result = false;
    if (this.state.formData.cmbState.length > 0) {
      this.state.State.map((row) => {
        if (row.vac_state === this.state.formData.cmbState) {
          result = true;
        }
      });
    }
    return result;
  };

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      //   {
      //     cType: "CtTxt",
      //     label: "SRNO",
      //     width: "100",
      //   },
      { cType: "Lbl", id: "vac_companyname" },
      { cType: "Lbl", id: "vac_customername" },
      {
        cType: "CtTxt",
        id: "vac_gstin",
        label: "GST IN",
        value: this.state.searchData.vac_gstin,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "vac_customer",
        label: "Customer Name",
        value: this.state.searchData.vac_customer,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_billingname",
        label: "Billing Name",
        value: this.state.searchData.vac_billingname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_personname",
        label: "Person Name",
        value: this.state.searchData.vac_personname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_referencename",
        label: "Reference Name",
        value: this.state.searchData.vac_referencename,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_address",
        label: "Address",
        value: this.state.searchData.vac_address,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_city",
        items: this.state.City,
        label: "City",
        value: this.state.searchData.vac_city,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
        colID: "City",
      },
      {
        cType: "CtTxt",
        id: "vac_state",
        items: this.state.State,
        label: "State",
        value: this.state.searchData.vac_state,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
        colID: "State",
      },
      {
        cType: "CtTxt",
        id: "vac_statecode",
        label: "State Code",
        value: this.state.searchData.vac_statecode,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "5",
      },
      {
        cType: "CtTxt",
        id: "vac_pincode",
        label: "Pin Code",
        value: this.state.searchData.vac_pincode,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "10",
      },
      {
        cType: "CtTxt",
        id: "vac_panno",
        label: "Pan No",
        value: this.state.searchData.vac_panno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "10",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "vac_mobileno1",
        label: "Mobile 1",
        value: this.state.searchData.vac_mobileno1,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "10",
      },
      {
        cType: "CtTxt",
        id: "vac_mobileno2",
        label: "Mobile 2",
        value: this.state.searchData.vac_mobileno2,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "10",
      },
      {
        cType: "CtTxt",
        id: "vac_email1",
        label: "Email 1",
        value: this.state.searchData.vac_email1,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_email2",
        label: "Email 2",
        value: this.state.searchData.vac_email2,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        id: "vac_openingamountcrdr",
        items: this.state.CrDr,
        label: "Cr/Dr",
        value: this.state.searchData.vac_openingamountcrdr,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        id: "dec_openingamount",
        label: "Opening Amount",
        value: this.state.searchData.dec_openingamount,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_remark",
        label: "Remark",
        value: this.state.searchData.vac_remark,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
      }
    );
    this.setState({ searchColumns });
  };

  getInfo = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "LoadCustomerDetails",
        // bint_acid: 1,
        bint_acid: localStorage.getItem("acid"),
        bolLoadState: true,
        bolLoadCity: true,
      };
      fetchCustomerMaster(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let rows = res.data.CustomerList,
            rowsCount = rows.length,
            State = res.data.StateList,
            City = res.data.CityList,
            GeneralSettingList = res.data.GeneralSettingList,
            Reference = res.data.ReferenceList;
          this.setState({
            dataLoadStatus,
            rows,
            rowsCount,
            State,
            City,
            GeneralSettingList,
            Reference,
          });
        })
        .catch((error) => {
          console.log("Unknown error occurred in onFormLoad.", error);
        });
    });
    document.getElementById("txtGSTIN").focus();
  };

  clearInfo = () => {
    const EditCustomerName = "",
      bint_srno = "",
      txtCompany = "",
      txtGSTIN = "",
      txtCustomerName = "",
      txtBillingName = "",
      txtPersonName = "",
      cmbReference = "",
      txtAddress = "",
      cmbCity = "",
      cmbState = "Gujarat",
      txtStateCode = "24",
      txtPANNo = "",
      txtMobileNo1 = "",
      txtMobileNo2 = "",
      txtEmail1 = "",
      txtEmail2 = "",
      cmbCrDr = "CR",
      txtOpeningAmount = "",
      txtRemark = "",
      editcustomer = "",
      txtPinCode = "";

    this.setState(
      {
        formData: {
          ...this.state.formData,
          EditCustomerName,
          bint_srno,
          txtCompany,
          txtGSTIN,
          txtCustomerName,
          txtBillingName,
          txtPersonName,
          cmbReference,
          txtAddress,
          cmbCity,
          cmbState,
          txtStateCode,
          txtPANNo,
          txtMobileNo1,
          txtMobileNo2,
          txtEmail1,
          txtEmail2,
          cmbCrDr,
          txtOpeningAmount,
          txtRemark,
          editcustomer,
          txtPinCode,
        },
      },
      () => {
        document.getElementById("txtGSTIN").focus();
      }
    );
  };

  OnGstInfoClick = () => {
    if (this.validateGstInfo()) {
      this.props.toastErrorMsg("Development Remain..");
    }
  };

  DeleteData = (EditCustomerName) => {
    if (EditCustomerName.length > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Customer : " + EditCustomerName + " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteCustomerMaster(EditCustomerName);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  SaveCustomerMaster = () => {
    if (this.validateCustomer()) {
      const dataLoadStatus = false;
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "SaveCustomer",
          // editcustomer: this.state.formData.txtEditCustomer,
          edit_customer: this.state.formData.EditCustomerName,
          bint_acid: localStorage.getItem("acid"),
          vac_company: localStorage.getItem("CompanyName"),
          bint_acyear: localStorage.getItem("ACY"),
          vac_gstin: this.state.formData.txtGSTIN,
          vac_customer: this.state.formData.txtCustomerName,
          vac_billingname: this.state.formData.txtBillingName,
          vac_personname: this.state.formData.txtPersonName,
          vac_referencename: this.state.formData.cmbReference,
          vac_address: this.state.formData.txtAddress,
          vac_city: this.state.formData.cmbCity,
          vac_state: this.state.formData.cmbState,
          vac_statecode: this.state.formData.txtStateCode,
          vac_panno: this.state.formData.txtPANNo,
          vac_mobileno1: this.state.formData.txtMobileNo1,
          vac_mobileno2: this.state.formData.txtMobileNo2,
          vac_email1: this.state.formData.txtEmail1,
          vac_email2: this.state.formData.txtEmail2,
          vac_openingamountcrdr: this.state.formData.cmbCrDr,
          dec_openingamount: this.state.formData.txtOpeningAmount,
          vac_remark: this.state.formData.txtRemark,
          vac_pincode: this.state.formData.txtPinCode,
        };
        fetchCustomerMaster(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              this.getInfo();
              this.clearInfo(true);
            } else {
              this.setState({
                dataLoadStatus: true,
              });
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in SaveLedgerDetail.", error);
          });
      });
    }
  };

  updateRefenceitemList = (Reference) => {
    this.setState({
      Reference,
    });
  };

  DeleteCustomerMaster = (txtCustomerName) => {
    this.props.notifyProcessing();
    this.setState({ dataLoadStatus: false }, () => {
      const reqData = {
        Op: "DeleteCustomer",
        bint_acid: localStorage.getItem("acid"),
        vac_customer: txtCustomerName,
      };
      fetchCustomerMaster(reqData)
        .then((res) => {
          // console.log("res", res.data);
          this.props.updateProcessing(res.data.msgType, res.data.message);
          if (res.data.msgType === "success") {
            this.setState({ ARD: null }, () => {
              this.getInfo();
              this.clearInfo(true);
            });
          } else {
            this.setState({ dataLoadStatus: true });
          }
        })
        .catch((error) => {
          this.props.updateProcessing(
            "error",
            "Unknown error occurred in delete DeleteLedgerDetail. " + error
          );
        });
    });
    return false;
  };

  onAddClickReference = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      this.removeKeyboardShortCuts();
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // alertTitle={'Sales Item Entry'}
          alertMessage={
            <ReferenceMaster
              updateRefenceitemList={this.updateRefenceitemList}
              showHeading={true}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
          handleOnClickNo={() => {
            this.ShortCut();
          }}
        />
      );
      this.setState({ ARD });
      document.getElementById("cmbReference").focus();
    });
  };

  openARDGstInfo = () => {
    let vac_gstin = this.state.formData.txtGSTIN;
    if (this.validateGstInfo()) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelDisagree="Close"
            alertMessage=<GstInfo
              vac_gstin={vac_gstin.toUpperCase()}
              update={this.update}
            />
            defaultOpenDialog={true}
          />
        );
        this.setState({ ARD });
      });
    }
  };

  update = (
    legalNameOfBusiness,
    tradeName,
    address,
    gstno,
    state,
    statecode
  ) => {
    this.setState({
      formData: {
        ...this.state.formData,
        txtCustomerName: tradeName,
        txtBillingName: tradeName,
        txtAddress: address.split(", ").slice(0, -4).join(", "),
        txtGSTIN: gstno,
        cmbState: state,
        txtStateCode: statecode,
        txtPANNo: gstno.substring(2, 12),
        txtPinCode: address.split(" ").pop(),
        cmbCity: address.split(", ").slice(-3, -2)[0] || "",
      },
      ARD: null,
    });
  };

  //#endregion function

  render() {
    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;
    // console.log("this.props.userPrivilege", this.props.userPrivilege);
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />

        {this.props.showHeading == true && (
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="title"
            spacing={2}
            marginTop={0}
            marginLeft={0}
          >
            <label
              htmlFor="Title"
              style={{ fontSize: "30px", color: "#515151" }}
            >
              <b>Customer Master</b>
            </label>
          </Grid>
        )}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          marginTop={0}
          marginLeft={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              margin={0}
            >
              <Grid item>
                <CtTxt
                  id="txtGSTIN"
                  value={this.state.formData.txtGSTIN}
                  label="GSTIN"
                  handleOnChange={this.handleOnChange}
                  width={150}
                  isUpperCase={true}
                  maxLength={15}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtCustomerName"
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Get GST Info."
                  onClick={this.openARDGstInfo}
                  variant="outlined"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              margin={0}
            >
              <Grid item>
                <CtTxt
                  id="txtCustomerName"
                  value={this.state.formData.txtCustomerName}
                  handleOnChange={this.handleOnChange}
                  label="Customer Name*"
                  width={170}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtBillingName"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtBillingName"
                  value={this.state.formData.txtBillingName}
                  handleOnChange={this.handleOnChange}
                  label="Billing Name"
                  width={180}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtPersonName"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtPersonName"
                  value={this.state.formData.txtPersonName}
                  handleOnChange={this.handleOnChange}
                  label="Person Name"
                  width={160}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbReference"
                />
              </Grid>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={2}
                margin={0}
              >
                <Grid item>
                  <CtCmbEditable
                    id="cmbReference"
                    label="Reference"
                    items={this.state.Reference}
                    value={this.state.formData.cmbReference}
                    handleOnChange={this.handleOnChange}
                    width={250}
                    maxLength={100}
                    colID="vac_referencename"
                    bolVisibleOnAddClickIcon={
                      this.props.userPrivilege.Reference == "A" ? true : false
                    }
                    onAddClick={this.onAddClickReference}
                    onKeyDown={this.props.onKeyDown}
                    nextCtrlID="txtAddress"
                  />
                </Grid>
              </Grid>
              <Grid item xs={10} sm={8}>
                <CtMultiLineText
                  id="txtAddress"
                  label="Address"
                  value={this.state.formData.txtAddress}
                  handleOnChange={this.handleOnChange}
                  width={"100%"}
                  maxLength={1000}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              margin={0}
            >
              <Grid item>
                <CtCmbEditable
                  id="cmbCity"
                  label="City"
                  items={this.state.City}
                  value={this.state.formData.cmbCity}
                  // disabled={this.state.disabledProfileData.AccountTypeDS}
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={50}
                  colID="vac_city"
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbState"
                />
              </Grid>
              <Grid item>
                <CtCmbEditable
                  id="cmbState"
                  label="State*"
                  items={this.state.State}
                  value={this.state.formData.cmbState}
                  // disabled={this.state.disabledProfileData.AccountTypeDS}
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={50}
                  colID="vac_state"
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID={"txtPinCode"}
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtStateCode"
                  label="State Code*"
                  disabled={true}
                  value={this.state.formData.txtStateCode}
                  handleOnChange={this.handleOnChange}
                  width={100}
                  maxLength={5}
                />
              </Grid>
              <Grid item>
                <CtTxtNum
                  id="txtPinCode"
                  label="Pin Code*"
                  value={this.state.formData.txtPinCode}
                  handleOnChange={this.handleOnChange}
                  width={80}
                  maxLength={6}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtPANNo"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtPANNo"
                  value={this.state.formData.txtPANNo}
                  label="PAN No"
                  handleOnChange={this.handleOnChange}
                  width={160}
                  isUpperCase={true}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtMobileNo1"
                />
              </Grid>
              <Grid item>
                <CtTxtNum
                  id="txtMobileNo1"
                  label="Mobile 1"
                  // disabled={true}
                  value={this.state.formData.txtMobileNo1}
                  handleOnChange={this.handleOnChange}
                  width={140}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtMobileNo2"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              margin={0}
            >
              <Grid item>
                <CtTxtNum
                  id="txtMobileNo2"
                  label="Mobile 2"
                  // disabled={true}
                  value={this.state.formData.txtMobileNo2}
                  handleOnChange={this.handleOnChange}
                  width={140}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtEmail1"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtEmail1"
                  label="Email 1"
                  // disabled={true}
                  value={this.state.formData.txtEmail1}
                  handleOnChange={this.handleOnChange}
                  width={160}
                  maxLength={50}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtEmail2"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtEmail2"
                  label="Email 2"
                  // disabled={true}
                  value={this.state.formData.txtEmail2}
                  handleOnChange={this.handleOnChange}
                  width={190}
                  maxLength={50}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbCrDr"
                />
              </Grid>
              <Grid item>
                <CtCmbEditable
                  id="cmbCrDr"
                  label="Cr/Dr"
                  items={this.state.CrDr}
                  value={this.state.formData.cmbCrDr}
                  handleOnChange={this.handleOnChange}
                  width={160}
                  maxLength={50}
                  colID="Type"
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtOpeningAmount"
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtOpeningAmount"
                  value={this.state.formData.txtOpeningAmount}
                  handleOnChange={this.handleOnChange}
                  label="Opening Amount"
                  width={190}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtRemark"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              margin={0}
            >
              <Grid item xs={10} sm={8}>
                <CtMultiLineText
                  id="txtRemark"
                  label="Remark"
                  value={this.state.formData.txtRemark}
                  handleOnChange={this.handleOnChange}
                  width={"100%"}
                  maxLength={1000}
                  // onKeyDown={this.props.onKeyDown}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              margin={0}
            >
              <Grid item>
                <CtBtn
                  label="Save"
                  onClick={() => {
                    this.trimFormData(() => {
                      this.SaveCustomerMaster();
                    });
                  }}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="New"
                  onClick={this.clearInfo}
                  variant="outlined"
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  onClick={() => {
                    this.DeleteData(this.state.formData.EditCustomerName);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <br />
        {/* <Grid container direction="row" justifyContent="center" alignItems="center" marginTop={0} marginLeft={0}> */}
        {/* <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={rows}
          rowsCount={rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          handleOnSearchChange={this.handleOnSearchChange}
          searchColumns={this.state.searchColumns}
          searchData={this.state.searchData}
          provideSearch={true}
          handleOnNewEntryClick={this.handleOnNewEntryClick}
          // toolTipNewEntry='New Product Entry'
        /> */}
        <CtART
          rowsdata={this.state.rows}
          columnsdata={this.state.columnsdata}
          rowsPerPage={this.state.rowsPerPage}
          tblmaxHeight={500}
          csvFileName={csvFileName("Customer")}
          rowIconAction={[
            {
              label: "Edit",
              onClick: this.handleARDonActionClick_Edit,
              icon: "Edit",
              className: "secondary-button",
            },
            {
              label: "Delete",
              onClick: this.handleARDonActionClick_Delete,
              icon: "delete",
              className: "delete-button",
            },
            // this.props.userPrivilege["Entry:Proposal"] == "M"
            //   ? {
            //       label: "Delete",
            //       onClick: this.handleARDonActionClick_Delete,
            //       icon: "delete",
            //       className: "delete-button",
            //     }
            //   : "",
          ]}
          // tableButtonAction={[
          //   {
          //     label: "Sales Entry",
          //     onClick: this.handleOnNewEntryClick,
          //     addPluseIcon: true,
          //   },
          //   // this.props.userPrivilege["Entry:Proposal"] != "R"
          //   //   ? {
          //   //       label: "Add New Proposal",
          //   //       onClick: this.handleOnNewEntryClick,
          //   //       addPluseIcon: true,
          //   //     }
          //   //   : "",
          // ]}
          showColumnFilters={false}
          actionColSize={90}
          hideColIdList={["vac_companyname", "vac_customername"]}
          density={"compact"}
        />
        {/* </Grid> */}
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}
export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(CustomerMaster)));
